export const getModelQueryKey = "models";
